import OnboardingChecklistCard from "./OnboardingChecklistCard";
import WeeklyDigestCard from "./WeeklyDigestCard";
import ROIProof from "./ROIProof";
import LeadershipSnapshot from "./LeadershipSnapshot";
import RecoveryList from "./RecoveryList";
import OwnerAlerts from "./OwnerAlerts";
import OwnerValueTile from "./OwnerValueTile";
import Leaderboards from "./Leaderboards";
import BoardPackAutoDispatch from "./BoardPackAutoDispatch";

/**
 * Owner Insights tab — deep ANALYSIS layer.
 *
 * NOTE — IA cleanup (2026-02-28):
 *   - ClientHealth removed → Operational Record §1 is the canonical owner.
 *   - ForecastPanel removed → Operational Record §4 is the canonical owner.
 *   - BoardSnapshot was never in Insights; removed from Owner Overview Row 4
 *     in the same pass (Operational Record §8 owns the narrative).
 *
 * Insights now hosts only analysis surfaces that drill DEEPER than the
 * Operational Record command surface:
 *   - Onboarding checklist (work)
 *   - Weekly Digest history (output)
 *   - ROI Proof (analysis composite — what intelligence captured)
 *   - Leadership Snapshot + Leaderboards (per-manager / per-fundraiser drill)
 *   - Recovery List (work — manager-coaching queue)
 *   - Owner Value Tile (30-day commercial framing)
 *   - Owner Alerts (legacy system_alert event log, distinct from Operational
 *     Record §7 rule-based alerts)
 *   - Board Pack Auto-Dispatch (governance work toggle)
 */
export default function OwnerInsightsTab({ onNavigate, onOpenFundraiser, readOnly = false }) {
  return (
    <div className="space-y-6" data-testid="owner-insights-tab">
      {/* Onboarding — auto-hides when 5/5 or dismissed */}
      <OnboardingChecklistCard />

      {/* Monthly Board Pack Auto-Dispatch — governance reliability moat (owner-only) */}
      {!readOnly && <BoardPackAutoDispatch />}

      {/* Weekly executive digest */}
      <WeeklyDigestCard />

      {/* ROI Proof — renewal-ready numbers (analysis composite, owner-only) */}
      {!readOnly && <ROIProof />}

      {/* Leadership Snapshot (6-tile, owner-only) */}
      {!readOnly && <LeadershipSnapshot />}

      {/* Recovery List — C/Risk graded managers ready to coach (owner-only) */}
      {!readOnly && <RecoveryList />}

      {/* 30-day Owner Value Tile */}
      <OwnerValueTile />

      {/* Alerts feed (legacy system_alert events) */}
      <OwnerAlerts
        onNavigate={onNavigate}
        onOpenFundraiser={onOpenFundraiser}
      />

      {/* Leaderboards (top 10 fundraisers) */}
      <Leaderboards />
    </div>
  );
}
